import { config } from '@/config';
export const AtributoService = {
    // Obtener un atributo desplegable por su ID
    async getAtributoById(id) {
        const response = await fetch(`${config.API_URL}/api/AtributoDesplegable/${id}`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error(`Error al obtener el atributo con ID ${id}`);
        }
        const datos = await response.json();
        return datos;
    },
    // Obtener todos los atributos desplegables
    async getAllAtributos() {
        const response = await fetch(`${config.API_URL}/api/AtributoDesplegable`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error('Error al obtener todos los atributos desplegables');
        }
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos)) {
            console.error('Se esperaba un array de atributos en la propiedad "datos" pero se recibió:', result);
            return []; // Devuelve un array vacío en caso de error
        }
        return result.datos;
    },
    // Obtener atributos desplegables por ID de repuesto
    async getAtributosByRepuestoId(repuestoId) {
        const response = await fetch(`${config.API_URL}/api/Repuesto/${repuestoId}/atributos-desplegables`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error(`Error al obtener los atributos para el repuesto con ID ${repuestoId}`);
        }
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos)) {
            console.error('Se esperaba un array de atributos en la propiedad "datos" pero se recibió:', result);
            return [];
        }
        return result.datos;
    },
    // Agregar un nuevo atributo desplegable
    async addAtributo(atributo) {
        const response = await fetch(`${config.API_URL}/api/AtributoDesplegable`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(atributo),
        });
        if (!response.ok) {
            throw new Error('Error al agregar el atributo desplegable');
        }
    },
    // Actualizar un atributo desplegable
    async updateAtributo(id, atributo) {
        const response = await fetch(`${config.API_URL}/api/AtributoDesplegable/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(atributo),
        });
        if (!response.ok) {
            throw new Error('Error al actualizar el atributo desplegable');
        }
    },
    // Eliminar un atributo desplegable
    async deleteAtributo(id) {
        const response = await fetch(`${config.API_URL}/api/AtributoDesplegable/${id}`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            throw new Error('Error al eliminar el atributo desplegable');
        }
    },
    // Actualizar el orden de múltiples atributos desplegables
    async updateOrdenAtributo(atributoID, nuevoOrden) {
        const response = await fetch(`${config.API_URL}/api/AtributoDesplegable/${atributoID}/orden`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(nuevoOrden),
        });
        if (!response.ok) {
            const error = await response.json();
            console.error('Error al actualizar orden:', error);
            throw new Error('No se pudo actualizar el orden');
        }
    }
};
